import { el } from 'https://cdn.venturz.co/lib/redom.es.js';

import {
  applyTraits
} from '/programs/utilities/language.js';

import InputRenderer from './input-renderer.js';

class Option {

  constructor(inputGroup) {

    this.input = null;
    this.label = null;
    this.inputGroup = inputGroup;

    this.inputType = 'radio';

    this.el = el('.checkbox-group-option', [
      this.renderLabel()
    ]);

  }

}

export default applyTraits(Option, [InputRenderer]);